import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, Form, Select, DatePicker, Spin, Table } from "antd";
import { getGender } from "../../redux/actions/gender.action";
import { ReadCookie } from "../../utils/readCookie";

import moment from "moment";
import logo from "../../assets/images/logo.png";
import xlsx from "../../assets/images/ico_xls_sm.gif";
import "../ProducList/productList.css";
import { TabTitle } from "../../utils/GeneralFunction.js";
import { getAllActiveRegion, getAllActiveSaleperson } from "../../redux/actions/getAllActive.js";
import { CSVLink } from "react-csv";
import { getStateUnique } from "../../redux/actions/state.action.js";
import { getSpecialityByMonth } from "../../redux/actions/specialityByStyle.js";

const SpecialityByMonth = ({ token }) => {
  TabTitle("Specialty By Month")
  const { gender, SpecialityByMonth, salePersonNew, RegionNew, State } = useSelector((state) => state);
  const menuId = ReadCookie("menuId");
  const userName = ReadCookie("name");
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { Option } = Select;
  const [loading, setLoading] = useState(false);
  const [excelData, setExcelData] = useState([])
  const tableRef = useRef(null);


  const columns = [
    {
      title: "#",
      className: "b_bottom",
      render: (text, record, index) => {
        return index + 1
      },
    },
    {
      title: "REGION",
      dataIndex: "region_name",
      key: "region_name",
      className: " b_left b_bottom",
      render: (text, record) => {
        return (
          <>
            {text}
          </>
        );
      },
      sorter: (a, b) => {
        if ((a.region_name !== null) & (b.region_name !== null)) {
          return a.region_name.localeCompare(b.region_name);
        }
      },
    },
    {
      title: "STATE",
      dataIndex: "state_name",
      key: "state_name",
      className: " b_left b_bottom",
      render: (text, record) => {
        return (
          <>
            {text}
          </>
        );
      },
      sorter: (a, b) => {
        if ((a.state_name !== null) & (b.state_name !== null)) {
          return a.state_name.localeCompare(b.state_name);
        }
      },
    },
    {
      title: "CITY",
      dataIndex: "city_name",
      key: "city_name",
      className: " b_left b_bottom",
      render: (text, record) => {
        return (
          <>
            {text}
          </>
        );
      },
      sorter: (a, b) => {
        if ((a.city_name !== null) & (b.city_name !== null)) {
          return a.city_name.localeCompare(b.city_name);
        }
      },
    },
    {
      title: "CUSTOMER",
      dataIndex: "customer_name",
      key: "customer_name",
      className: " b_left b_bottom",
      sorter: (a, b) => {
        if ((a.customer_name !== null) & (b.customer_name !== null)) {
          return a.customer_name.localeCompare(b.customer_name);
        }
      },
    },
    {
      title: "LAST YEAR",
      children: [
        {
          title: "JAN",
          dataIndex: "january_ly",
          key: "january_ly",
          className: "b_left b_right_none b_bottom",
          sorter: (a, b) => {
            return a.january_ly - b.january_ly
          },
        },
        {
          title: "FEB",
          dataIndex: "february_ly",
          key: "february_ly",
          align: "right",
          className: "b_left b_right_none b_bottom",
          sorter: (a, b) => {
            return a.february_ly - b.february_ly
          },
        },
        {
          title: "MAR",
          dataIndex: "march_ly",
          key: "march_ly",
          align: "right",
          className: "b_left b_right_none b_bottom",
          sorter: (a, b) => {
            return a.march_ly - b.march_ly
          },
        },
        {
          title: "APR",
          dataIndex: "april_ly",
          key: "april_ly",
          align: "right",
          className: "b_left b_right_none b_bottom",
          sorter: (a, b) => {
            return a.april_ly - b.april_ly
          },
        },
        {
          title: "MAY",
          dataIndex: "may_ly",
          key: "may_ly",
          align: "right",
          className: "b_left b_right_none b_bottom",
          sorter: (a, b) => {
            return a.may_ly - b.may_ly
          },
        },
        {
          title: "JUN",
          dataIndex: "june_ly",
          key: "june_ly",
          align: "right",
          className: "b_left b_right_none b_bottom",
          sorter: (a, b) => {
            return a.june_ly - b.june_ly
          },
        },
        {
          title: "SPRING",
          dataIndex: "spring_ly",
          key: "spring_ly",
          align: "right",
          className: "b_left b_right_none b_bottom",
          render: (text, record) => {
            return {
              props: {
                style: { background: '#E8F2FC' }
              },
              children: <div>{parseFloat(text).toLocaleString('en-US')}</div>
            }
          },
          sorter: (a, b) => {
            return a.spring_ly - b.spring_ly
          },
        },
        {
          title: "JUL",
          dataIndex: "july_ly",
          key: "july_ly",
          align: "right",
          className: "b_left b_right_none b_bottom",
          sorter: (a, b) => {
            return a.july_ly - b.july_ly
          },
        },
        {
          title: "AUG",
          dataIndex: "august_ly",
          key: "august_ly",
          align: "right",
          className: "b_left b_right_none b_bottom",
          sorter: (a, b) => {
            return a.august_ly - b.august_ly
          },
        },
        {
          title: "SEP",
          dataIndex: "september_ly",
          key: "september_ly",
          align: "right",
          className: "b_left b_right_none b_bottom",
          sorter: (a, b) => {
            return a.september_ly - b.september_ly
          },
        },
        {
          title: "OCT",
          dataIndex: "october_ly",
          key: "october_ly",
          align: "right",
          className: "b_left b_right_none b_bottom",
          sorter: (a, b) => {
            return a.october_ly - b.october_ly
          },
        },
        {
          title: "NOV",
          dataIndex: "november_ly",
          key: "november_ly",
          align: "right",
          className: "b_left b_right_none b_bottom",
          sorter: (a, b) => {
            return a.november_ly - b.november_ly
          },
        },
        {
          title: "DEC",
          dataIndex: "december_ly",
          key: "december_ly",
          align: "right",
          className: "b_left b_right_none b_bottom",
          sorter: (a, b) => {
            return a.december_ly - b.december_ly
          },
        },
        {
          title: "FALL",
          dataIndex: "fall_ly",
          key: "fall_ly",
          align: "right",
          className: "b_left b_right_none b_bottom",
          render: (text, record) => {
            return {
              props: {
                style: { background: '#E8F2FC' }
              },
              children: <div>{(text)}</div>
            }
          },
          sorter: (a, b) => {
            return a.fall_ly - b.fall_ly
          },
        },
        {
          title: "TOTAL",
          dataIndex: "total_ly",
          key: "total_ly",
          align: "right",
          className: "b_left b_right_none b_bottom",
          render: (text, record) => {
            return {
              props: {
                style: { background: '#E8F2FC' }
              },
              children: <div>{(text)}</div>
            }
          },
          sorter: (a, b) => {
            return a.total_ly - b.total_ly
          },
        },
      ],
    },
    {
      title: "THIS YEAR",
      children: [
        {
          title: "JAN",
          dataIndex: "january_cy",
          key: "january_cy",
          className: "b_left b_right_none b_bottom",
          align: "right",
          sorter: (a, b) => {
            return a.january_cy - b.january_cy
          },
        },
        {
          title: "FEB",
          dataIndex: "february_cy",
          key: "february_cy",
          align: "right",
          className: "b_left b_bottom",
          sorter: (a, b) => {
            return a.february_cy - b.february_cy
          },
        },
        {
          title: "MAR",
          dataIndex: "march_cy",
          key: "march_cy",
          align: "right",
          sorter: (a, b) => {
            return a.march_cy - b.march_cy
          },
        },
        {
          title: "APR",
          dataIndex: "april_cy",
          key: "april_cy",
          align: "right",
          className: "b_left b_right_none b_bottom",
          sorter: (a, b) => {
            return a.april_cy - b.april_cy
          },
        },
        {
          title: "MAY",
          dataIndex: "may_cy",
          key: "may_cy",
          align: "right",
          className: "b_left b_right_none b_bottom",
          sorter: (a, b) => {
            return a.may_cy - b.may_cy
          },
        },
        {
          title: "JUN",
          dataIndex: "june_cy",
          key: "june_cy",
          align: "right",
          className: "b_left b_right_none b_bottom",
          sorter: (a, b) => {
            return a.june_cy - b.june_cy
          },
        },
        {
          title: "SPRING",
          dataIndex: "spring_cy",
          key: "spring_cy",
          align: "right",
          className: "b_left b_right_none b_bottom",
          render: (text, record) => {
            return {
              props: {
                style: { background: '#E8F2FC' }
              },
              children: <div>{parseFloat(text).toLocaleString('en-US')}</div>
            }
          },
          sorter: (a, b) => {
            return a.spring_cy - b.spring_cy
          },
        },
        {
          title: "JUL",
          dataIndex: "july_cy",
          key: "july_cy",
          align: "right",
          className: "b_left b_right_none b_bottom",
          sorter: (a, b) => {
            return a.july_cy - b.july_cy
          },
        },
        {
          title: "AUG",
          dataIndex: "august_cy",
          key: "august_cy",
          align: "right",
          className: "b_left b_right_none b_bottom",
          sorter: (a, b) => {
            return a.august_cy - b.august_cy
          },
        },
        {
          title: "SEP",
          dataIndex: "september_cy",
          key: "september_cy",
          align: "right",
          className: "b_left b_right_none b_bottom",
          sorter: (a, b) => {
            return a.september_cy - b.september_cy
          },
        },
        {
          title: "OCT",
          dataIndex: "october_cy",
          key: "october_cy",
          align: "right",
          className: "b_left b_right_none b_bottom",
          sorter: (a, b) => {
            return a.october_cy - b.october_cy
          },
        },
        {
          title: "NOV",
          dataIndex: "november_cy",
          key: "november_cy",
          align: "right",
          className: "b_left b_right_none b_bottom",
          sorter: (a, b) => {
            return a.november_cy - b.november_cy
          },
        },
        {
          title: "DEC",
          dataIndex: "december_cy",
          key: "december_cy",
          align: "right",
          className: "b_left b_right_none b_bottom",
          sorter: (a, b) => {
            return a.december_cy - b.december_cy
          },
        },
        {
          title: "FALL",
          dataIndex: "fall_cy",
          key: "fall_cy",
          align: "right",
          className: "b_left b_right_none b_bottom",
          render: (text, record) => {
            return {
              props: {
                style: { background: '#E8F2FC' }
              },
              children: <div>{parseFloat(text).toLocaleString('en-US')}</div>
            }
          },
          sorter: (a, b) => {
            return a.fall_cy - b.fall_cy
          },
        },
        {
          title: "TOTAL",
          dataIndex: "total_cy",
          key: "total_cy",
          align: "right",
          className: "b_left b_right_none b_bottom",
          render: (text, record) => {
            return {
              props: {
                style: { background: '#E8F2FC' }
              },
              children: <div>{parseFloat(text).toLocaleString('en-US')}</div>
            }
          },
          sorter: (a, b) => {
            return a.total_cy - b.total_cy
          },
        },
      ],
    },
    {
      title: "$ DIFF. TY/LY",
      dataIndex: "diff_cy_ly",
      key: "diff_cy_ly",
      align: "right",
      className: " b_left b_bottom",
      render: (text, record) => {
        return {
          props: {
            style: {
              color: text < 0 ? 'red' : 'inherit' // Set color conditionally
            }
          },
          children: `${parseFloat(text).toLocaleString('en-US')}`
        };
      },
      sorter: (a, b) => {
        return a.diff_cy_ly - b.diff_cy_ly
      },
    },
    {
      title: "STATUS",
      dataIndex: "status",
      key: "status",
      align: "right",
      className: " b_left b_bottom",
      sorter: (a, b) => {
        return a.status - b.status
      },
    },
  ];


  function downloadExcelFileData(data) {
    setExcelData(
      data.map((v) => {
        return {
          "REGION": v.region_name,
          "STATE": v.state_name,
          "CITY": v.city_name,
          "CUSTOMER": v.customer_name,
          "JAN-LY": v.january_ly,
          "FEB-LY": v.february_ly,
          "MAR-LY": v.march_ly,
          "APR-LY": v.april_ly,
          "MAY-LY": v.may_ly,
          "JUN-LY": v.june_ly,
          "SPRING-LY": v.spring_ly,
          "JUL-LY": v.july_ly,
          "AUG-LY": v.august_ly,
          "SEP-LY": v.september_ly,
          "OCT-LY": v.october_ly,
          "NOV-LY": v.november_ly,
          "DEC-LY": v.december_ly,
          "FALL-LY": v.fall_ly,
          "JAN-CY": v.january_cy,
          "FEB-CY": v.february_cy,
          "MAR-CY": v.march_cy,
          "APR-CY": v.april_cy,
          "MAY-CY": v.may_cy,
          "JUN-CY": v.june_cy,
          "SPRING-CY": v.spring_cy,
          "JUL-CY": v.july_cy,
          "AUG-CY": v.august_cy,
          "SEP-CY": v.september_cy,
          "OCT-CY": v.october_cy,
          "NOV-CY": v.november_cy,
          "DEC-CY": v.december_cy,
          "FALL-CY": v.fall_cy,
          "$ DIFF. TY/LY": v.diff_cy_ly,
          "STATUS": v.status,
        };
      })
    )
  }

  useEffect(() => {
    dispatch(getAllActiveSaleperson(token, menuId));
    dispatch(getGender(token, menuId));
    dispatch(getAllActiveRegion(token, menuId));
    dispatch(getStateUnique(token))
  }, []);

  const onFinish = async (e) => {
    setLoading(true);
    await form.validateFields().then((values) => {
      dispatch(getSpecialityByMonth(token, values)).then((res) => {
        setLoading(false);
        downloadExcelFileData(res?.payload?.data);
      });
    });
  };


  const handlePrint = () => {
    window.print();
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col">
            <div className="report-wrapper-main header_class">
              <div className="row justify-content-between pb-0">
                <div className="col-3 d-flex align-items-start  box-space">
                  <div className="logobrand">
                    <img id="ImgLogo" alt="logo" src={logo} />
                  </div>
                </div>

                <div className="col-3 box-space right-content-header text-right">
                  <div className=" d-flex justify-content-end">
                    <div className=" d-flex justify-content-end printing_class">
                      <div className="print_icon printing_class">
                        <i
                          id="Image1"
                          title="Print"
                          alt="Print"
                          className="fa-solid fa-print printing_class"
                          onClick={handlePrint}
                        ></i>
                      </div>
                      <div className="print_icon printing_class">
                        {SpecialityByMonth?.payload?.data ? (
                          <CSVLink
                            filename={"Specialty-By-Month.csv"}
                            data={excelData}
                            onClick={() => {
                            }}
                          >
                            <input
                              type="image"
                              name="ImgExcel"
                              alt="Export to excel"
                              id="ImgExcel"
                              title="Export to excel"
                              src={xlsx}
                              style={{ borderWidth: "0px", height: "14px" }}
                            />
                          </CSVLink>
                        ) : (
                          <input
                            type="image"
                            name="ImgExcel"
                            alt="Export to excel"
                            id="ImgExcel"
                            title="Export to excel"
                            src={xlsx}
                            style={{ borderWidth: "0px", height: "14px" }}
                          />
                        )}
                      </div>
                    </div>
                    <span style={{ fontWeight: "bolder" }}>
                      Specialty By Month
                      <br />
                      Rpt # 006
                      <br />
                      Login as:
                      <span id="lblSalesPerson" style={{ fontWeight: "bold" }}>
                        {" "}
                        {userName}
                      </span>

                    </span>
                  </div>
                </div>
              </div>
              <div className="row pb-2">
                <div className="col">
                  <Form
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    layout="horizontal"
                    form={form}
                    name="control-hooks"
                    onFinish={onFinish}
                  >
                    <div className="main_form row">
                      <div className=" col-6">
                        <div className=" d-flex flex-row align-items-baseline">
                          <label htmlFor="gender_id" className="labels width30">
                            Year:
                          </label>
                          <div className=" w-100">
                            <Form.Item
                              name="year"
                              initialValue={moment("2026", "YYYY")}
                              className="formFullWidth"
                            >
                              <DatePicker
                                size="small"
                                className="filter-fields full_date"
                                picker="year"
                              />
                            </Form.Item>
                          </div>
                        </div>
                        <div className=" d-flex flex-row align-items-baseline">
                          <label htmlFor="" className="labels width30">Sale Person</label>
                          <div style={{ marginBottom: "-5px" }} className=" w-100">
                            <Form.Item
                              name="salePerson"
                              initialValue={"All"}
                              className="formFullWidth"
                            >
                              <Select
                                allowClear
                                size="small"
                                showSearch
                                optionFilterProp="children"
                                className="filter-fields"
                                loading={salePersonNew?.loading}
                                defaultValue="All"
                                filterSort={(optionA, optionB) =>
                                  optionB?.value !== null ?
                                    optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                                }
                              >
                                <Option value={null}>All</Option>
                                {salePersonNew?.payload?.data.map((item) => {
                                  return (
                                    <Option
                                      defaultValue={"All"}
                                      key={item.sales_person_id}
                                      value={item.sales_person_id}
                                    >
                                      {item.salesperson_name}
                                    </Option>
                                  );
                                })}
                              </Select>
                            </Form.Item>
                          </div>
                        </div>
                        <div className=" d-flex flex-row align-items-baseline">
                          <label htmlFor="" className="labels width30">State</label>
                          <div style={{ marginBottom: "-5px" }} className=" w-100">
                            <Form.Item
                              name="stateID"
                              initialValue={"All"}
                              className="formFullWidth"
                            >
                              <Select
                                allowClear
                                size="small"
                                showSearch
                                optionFilterProp="children"
                                className="filter-fields"
                                loading={State?.loading}
                                defaultValue="All"
                                filterSort={(optionA, optionB) =>
                                  optionB?.value !== null ?
                                    optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                                }
                              >
                                <Option value={null}>All</Option>
                                {State?.payload?.data.map((item) => {
                                  return (
                                    <Option
                                      defaultValue={"All"}
                                      key={item.state_name}
                                      value={item.state_name}
                                    >
                                      {item.state_name}
                                    </Option>
                                  );
                                })}
                              </Select>
                            </Form.Item>
                          </div>
                        </div>
                      </div>
                      <div className=" col-6">
                        <div className=" d-flex flex-row align-items-baseline">
                          <label htmlFor="" className="labels width30">Gender</label>
                          <div style={{ marginBottom: "-5px" }} className=" w-100">
                            <Form.Item
                              name="gender"
                              initialValue={"All"}
                              className="formFullWidth"
                            >
                              <Select
                                allowClear
                                size="small"
                                showSearch
                                optionFilterProp="children"
                                className="filter-fields"
                                loading={gender?.loading}
                                defaultValue="All"
                                filterSort={(optionA, optionB) =>
                                  optionB?.value !== null ?
                                    optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                                }
                              >
                                <Option value={null}>All</Option>
                                {gender?.payload?.data.map((item) => {
                                  return (
                                    <Option
                                      defaultValue={"All"}
                                      key={item.gender_id}
                                      value={item.gender_id}
                                    >
                                      {item.gender_name}
                                    </Option>
                                  );
                                })}
                              </Select>
                            </Form.Item>
                          </div>
                        </div>
                        <div className=" d-flex flex-row align-items-baseline">
                          <label htmlFor="" className="labels width30">Region</label>
                          <div className=" w-100">
                            <Form.Item
                              name="region"
                              initialValue={"All"}
                              className="formFullWidth"
                            >
                              <Select
                                allowClear
                                size="small"
                                showSearch
                                optionFilterProp="children"
                                defaultValue="All"
                                className="filter-fields"
                                loading={RegionNew?.loading}
                                filterSort={(optionA, optionB) =>
                                  optionB?.value !== null ?
                                    optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                                }
                              >
                                <Option value={null}>All</Option>
                                {RegionNew?.payload?.data.map((item) => {
                                  return (
                                    <Option
                                      defaultValue={"All"}
                                      key={item.region_id}
                                      value={item.region_id}
                                    >
                                      {item.region_name}
                                    </Option>
                                  );
                                })}
                              </Select>
                            </Form.Item>
                          </div>
                        </div>
                        <div className=" d-flex flex-row align-items-baseline">
                          <label htmlFor="gender_id" className="labels width30">
                            Status
                          </label>
                          <div style={{ marginBottom: "-2px" }} className=" w-100">
                            <Form.Item
                              name="status_id"
                              className="formFullWidth"
                            >
                              <Select
                                allowClear
                                size="small"
                                showSearch
                                optionFilterProp="children"
                                defaultValue="All"
                                className={"select_Inputs"}
                              >
                                <Option key={null} value={null}>
                                  All
                                </Option>
                                <Option key={"EXISTING"} value={"EXISTING"}>
                                  EXISTING
                                </Option>
                                <Option key={"NEW"} value={"NEW"}>
                                  NEW
                                </Option>
                                <Option key={"INACTIVE"} value={"INACTIVE"}>
                                  INACTIVE
                                </Option>
                              </Select>
                            </Form.Item>
                          </div>
                        </div>
                        <div style={{ marginTop: "0px", display: "flex", justifyContent: "end" }} >
                          <Button type="primary" htmlType="submit" className='submit-btn-btm m-0' disabled={loading}>
                            Search
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="table_content"
        style={{ width: '100%' }}
        ref={tableRef}
      >
        <div>
          {loading ? (
            <div className="d-flex align-items-center justify-content-center spin-style mt-3">
              <Spin />
            </div>
          ) : SpecialityByMonth?.payload?.data.length ? (
            <Table
              style={{ fontSize: '10.3px' }}
              className="test04 mt-3 sales_target_report_table sales_report_res_table_intransit ledger_print speciality_customer_size sales_report_res_table dropship-table-height sales_report_res_table_month"
              size="small"
              pagination={{ pageSize: 100 }}
              columns={columns}
              // scroll={{ x: 'max-content' }}
              dataSource={SpecialityByMonth?.payload?.data}
            />

          ) : (
            <div
              style={{
                backgroundColor: '#CCCCCC',
                borderWidth: '1pt',
                borderStyle: 'Dashed',
                fontWeight: 'bold',
                height: '25px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              No record(s)
            </div>
          )}
        </div>
      </div>

    </>
  );
};

export default SpecialityByMonth;